<div class="row page-header">
    <div class="col-12">
        <h1>Divisions <small>Define divisions, their project types, and assigned jobs</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" style="margin-bottom: 10px">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Divisions</a>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Job Assignments</a>
        </li>
    </ul>

    <div class="row" [hidden]="active !== 1">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="divisionsGrid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="divisionsGrid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="searchDivisions" [(ngModel)]="divisionsGrid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="divisionsGrid"
                        #divisionsGridEl
                        appAutoSize
                        (initialized)="divisionsGrid.initialize(divisionsGridEl)"
                        (destroy)="divisionsGrid.destroy()"
                        [itemsSource]="divisionsGrid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Sort Order'"
                            [binding]="'sortOrder'"
                            [width]="120"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'# Project Types'"
                            [binding]="'jobTypeCount'"
                            [width]="160"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Project Types'"
                            [binding]="'jobTypeNames'"
                            [width]="'2*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Archived'"
                            [binding]="'archived'"
                            [width]="110"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>

    <div class="row" [hidden]="active !== 2">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="projectAssignmentsGrid"></action-toolbar-count>
                        <action-toolbar-search
                            name="searchProjects"
                            [(ngModel)]="projectAssignmentsGrid.filter"
                        ></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="projectAssignmentsGrid"
                        #projectAssignmentsGridEl
                        appAutoSize
                        (initialized)="projectAssignmentsGrid.initialize(projectAssignmentsGridEl)"
                        (destroy)="projectAssignmentsGrid.destroy()"
                        [itemsSource]="projectAssignmentsGrid.view"
                        (beginningEdit)="cellBeginningEdit(projectAssignmentsGridEl, $event)"
                        (cellEditEnded)="cellEditEnded(projectAssignmentsGridEl, $event)"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Job Number'"
                            [binding]="'id'"
                            [width]="180"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Job Name'"
                            [binding]="'name'"
                            [width]="'2*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Division'"
                            [binding]="'divisionId'"
                            [width]="'*'"
                            [dataMap]="divisionMap"
                            [isReadOnly]="!canEdit"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
